export function getMousePosition(event) {
  return {
    x: event.clientX,
    y: event.clientY,
  };
}
